// extracted by mini-css-extract-plugin
export default {"JsonSettingsEditor":"JsonSettingsEditor_JsonSettingsEditor__z9aGd"};